import { createStore } from "vuex";
import { api } from "@/helpers/api";

const savedToken = localStorage.getItem("facturize_token");
const savedUser = JSON.parse(localStorage.getItem("facturize_user") || "null");

export default createStore({
  state: { token: savedToken, user: savedUser, notifications: [] },
  getters: {
    authenticated: (state) => Boolean(state.token && state.user),
    manager: (state) => state.user,
    unreadNotifications: (state) =>
      state.notifications.filter((item) => !item.lida).length,
  },
  mutations: {
    SET_SESSION(state, { token, user }) {
      state.token = token;
      state.user = user;
    },
    CLEAR_SESSION(state) {
      state.token = null;
      state.user = null;
      state.notifications = [];
    },
    SET_NOTIFICATIONS(state, data) {
      state.notifications = data;
    },
    ADD_NOTIFICATION(state, data) {
      state.notifications.unshift(data);
    },
    READ_NOTIFICATION(state, id) {
      const item = state.notifications.find((row) => row.id === id);
      if (item) item.lida = true;
    },
    READ_ALL(state) {
      state.notifications.forEach((item) => {
        item.lida = true;
      });
    },
  },
  actions: {
    async login({ commit }, credentials) {
      const { data } = await api.post("/auth/login", credentials);
      localStorage.setItem("facturize_token", data.token);
      localStorage.setItem("facturize_user", JSON.stringify(data.user));
      commit("SET_SESSION", data);
      return data;
    },
    async registerCompany({ commit }, payload) {
      const { data } = await api.post("/auth/register-company", payload);
      localStorage.setItem("facturize_token", data.token);
      localStorage.setItem("facturize_user", JSON.stringify(data.user));
      commit("SET_SESSION", data);
      return data;
    },
    async restore({ commit, state }) {
      if (!state.token) return false;
      try {
        const { data } = await api.get("/auth/me");
        localStorage.setItem("facturize_user", JSON.stringify(data.user));
        commit("SET_SESSION", { token: state.token, user: data.user });
        return true;
      } catch (_) {
        commit("CLEAR_SESSION");
        localStorage.removeItem("facturize_token");
        localStorage.removeItem("facturize_user");
        return false;
      }
    },
    async logout({ commit }) {
      try {
        await api.post("/auth/logout");
      } catch (_) {
        /* encerra localmente */
      }
      localStorage.removeItem("facturize_token");
      localStorage.removeItem("facturize_user");
      commit("CLEAR_SESSION");
    },
    async loadNotifications({ commit }) {
      const { data } = await api.get("/system/notificacoes");
      commit("SET_NOTIFICATIONS", data.data || []);
    },
    async readNotification({ commit }, id) {
      await api.post(`/system/notificacoes/${id}/ler`);
      commit("READ_NOTIFICATION", id);
    },
    async readAll({ commit }) {
      await api.post("/system/notificacoes/ler-todas");
      commit("READ_ALL");
    },
  },
});
